import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2'
import { CommercialLicenseMappingsComponent } from './commercial-license-mappings.component'
import { CreateCommercialLicenseMappingComponent } from './create-commercial-license-mapping/create-commercial-license-mapping.component'
import { UpdateCommercialLicenseMappingComponent } from './update-commercial-license-mapping/update-commercial-license-mapping.component'
import { commercialLicenseMappingsRoutes } from './commercial-license-mappings.routing'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HttpClientModule } from '@angular/common/http'
import { RouterModule } from '@angular/router'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { SharedModule } from '../../shared/shared.module'

@NgModule({
  declarations: [
    CommercialLicenseMappingsComponent,
    CreateCommercialLicenseMappingComponent,
    UpdateCommercialLicenseMappingComponent,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
    BrowserAnimationsModule,
    SweetAlert2Module.forRoot(),
    RouterModule.forRoot(commercialLicenseMappingsRoutes, {
      scrollPositionRestoration: 'top',
    }),
    HttpClientModule,
    SharedModule,
  ],
  exports: [
    CommercialLicenseMappingsComponent,
    CreateCommercialLicenseMappingComponent,
    UpdateCommercialLicenseMappingComponent,
  ],
})
export class CommercialLicenseMappingsModule {}
